
import React from 'react';
import { withStyles, Grid, Tabs, Tab, withRouter } from '../../material-ui';
import MBack from '../view/MBack';
import {
    MatchSchedule,
    MatchSocreRankBasketball,
    MatchSocreRankFootball,
    MatchRankTeamBasketball,
    MatchRankTeamFootball,
    MatchRankPlayerFootball,
    MatchRankPlayerBasketball
} from './view';

import MTabPanel from '../view/MTabPanel';
import MatchType from '../../model/MatchType';
import AppUtils from '../../control/apputlis';
import TabIndicator from '../view/TabIndicator';

class MatchDetail extends React.Component {

    constructor(props) {
        super(props);

        let { data } = this.props.location;
        if (data) {
            AppUtils.setStorageObj(AppUtils.MATCH_DETAIL_DATA, data);
        } else {
            data = AppUtils.getStorageObj(AppUtils.MATCH_DETAIL_DATA);
        }
        this.state = {
            value: 0,
            data: data,
        };
        console.log('MatchDetail', data);
    }

    componentDidMount() {
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    _handleChange(val) {
        this.setState({ value: val });
    }

    render() {
        const { classes } = this.props;
        const { value, data } = this.state;
        console.log('_handleChange', value, data);
        let competition_id = data ? data.competition_id : 0;
        let type_id = data ? data.type_id : 0;

        let name = '比赛详情';
        if (data) {
            if (data.short_name_zh) {
                name = data.short_name_zh;
            } else if (data.name) {
                name = data.name;
            }
        }

        return (
            <MBack title={name}>
                <Grid container justifyContent='space-between' alignItems='center' direction='row'>
                    <Grid container alignItems='center' style={{ flex: 1, backgroundColor: '#FFF', marginTop: 8 }}>
                        <Tabs
                            value={value}
                            variant='fullWidth'
                            onChange={(e, val) => this._handleChange(val)}
                            TabIndicatorProps={{ children: <TabIndicator />, style: { backgroundColor: 'transparent', marginBottom: 1.5 } }}
                            style={{ minHeight: 32, width: '100vw' }}
                        >
                            <Tab label='积分榜' style={{ color: value == 0 ? '#0D0D0D' : '#878787', fontSize: 14, minHeight: 32, padding: 0 }} ></Tab>
                            <Tab label='赛程' style={{ color: value == 1 ? '#0D0D0D' : '#878787', fontSize: 14, minHeight: 32, padding: 0 }} ></Tab>
                            <Tab label='球队榜' style={{ color: value == 2 ? '#0D0D0D' : '#878787', fontSize: 14, minHeight: 32, padding: 0 }} ></Tab>
                            <Tab label='球员榜' style={{ color: value == 3 ? '#0D0D0D' : '#878787', fontSize: 14, minHeight: 32, padding: 0 }} ></Tab>
                        </Tabs>
                    </Grid>
                </Grid>
                <Grid style={{ height: 1, backgroundColor: '#F7F7F7', width: '100%' }}></Grid>
                <Grid container direction='row' className={classes.list} >
                    <MTabPanel value={value} index='0' style={{ width: '100%' }}>
                        {
                            type_id == MatchType.BASKETBALL && <MatchSocreRankBasketball competition_id={competition_id} />
                        }
                        {
                            type_id == MatchType.FOOTBALL && <MatchSocreRankFootball competition_id={competition_id} />
                        }
                    </MTabPanel>
                    <MTabPanel value={value} index='1' style={{ width: '100%' }}>
                        <MatchSchedule type_id={type_id} competition_id={competition_id} />
                    </MTabPanel>
                    <MTabPanel value={value} index='2' style={{ width: '100%' }}>
                        {
                            type_id == MatchType.BASKETBALL && <MatchRankTeamBasketball competition_id={competition_id} />
                        }
                        {
                            type_id == MatchType.FOOTBALL && <MatchRankTeamFootball competition_id={competition_id} />
                        }
                    </MTabPanel>
                    <MTabPanel value={value} index='3' style={{ width: '100%' }}>
                        {
                            type_id == MatchType.BASKETBALL && <MatchRankPlayerBasketball competition_id={competition_id} />
                        }
                        {
                            type_id == MatchType.FOOTBALL && <MatchRankPlayerFootball competition_id={competition_id} />
                        }
                    </MTabPanel>
                </Grid>
            </MBack>
        );
    }

}

export default withRouter(withStyles((theme) => ({
    list: {
        padding: theme.spacing(0, 0, 0, 0),
        marginTop: theme.spacing(0),
        backgroundColor: '#FFF',
    }

}))(MatchDetail));